import React, { Component } from 'react';

class Loader extends Component {

    render(){
        return(
        <div    
        align="center"
        style = {{
            height: '100%',
            width: '100%'
        }}
        >

            <img
            src="static/images/animations/Cube-Loader.svg"
            style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: '100px',
                height: '100px',
                'margin-top': '-20px', /* Half the height */
                'margin-left': '-20px'
            }}
            />

        </div>
        )
    }

}

export default (Loader);



// WEBPACK FOOTER //
// ./src/other-components/loader/loader.js